import { z } from 'zod/v4';

export const mapUpdateFrequencySchema = z.object({
  recurringUpdatesPerYear: z.number().optional(),
  updateTimeframe: z.string(),
});

export type MapUpdateFrequency = z.infer<typeof mapUpdateFrequencySchema>;
